import {combineReducers} from "redux";
import AuthReducer from "../reducers/AuthReducer";
import AppReducer from "../reducers/AppReducer";

const RootReducer = combineReducers({
    AuthReducer: AuthReducer,
    AppReducer:AppReducer
})

export default RootReducer;
